import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { testimonialsData } from './testimonialsData';
import TestimonialItem from './TestimonialItem';
import { TestimonialsWrapper } from './styled';

function Testimonials(): JSX.Element {
  return (
    <TestimonialsWrapper>
      <Typography variant="h2" component="div" marginBottom="30px">
        Testimonials
      </Typography>
      <Container className="testimonials-data-container">
        <Grid container>
          {testimonialsData.map((item, index) => (
            <Grid
              className={`testimonial-item-container ${
                index !== testimonialsData.length - 1 ? 'not-last' : 'not-first'
              }`}
              item
              xs={12}
              sm={6}
              md={6}
              key={item.name}>
              <TestimonialItem
                name={item.name}
                imgUrl={item.imgUrl}
                text={item.text}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </TestimonialsWrapper>
  );
}

export default Testimonials;
